import { FC } from "react";
import { Navigate, useParams } from "react-router-dom";

const LEGACY_ACADEMIC_TAB_MAP: Record<string, string> = {
  obep: "obep",
  courses: "courses",
  classes: "classes",
  subjects: "subjects",
  syllabus: "syllabus",
  "syllabus-assignment": "syllabus/assignment",
  "grade-levels": "scoring-rubrics",
  "scoring-rubrics": "scoring-rubrics",
};

const AcademicLegacyTabRedirect: FC = () => {
  const { tab } = useParams<{ tab: string }>();
  const suffix = tab ? LEGACY_ACADEMIC_TAB_MAP[tab] : undefined;
  const target = suffix ? `/academics/${suffix}` : "/academics/obep";
  return <Navigate to={target} replace />;
};

export default AcademicLegacyTabRedirect;
